export const preventEvents = fn => {
  return evt => {
    evt.stopPropagation();
    evt.preventDefault();
    fn && fn();
  };
};
